import {
  NotificationActionType as Action,
  NotificationMetadataStatus,
  NotificationStatus,
} from '@aibees/shared/features/notifications';
import { useUpdateNotificationStatusMutationApi } from '@aibees/shared/features/notifications/api/use-update-notification-status-mutation-api';
import { useNotificationStore } from '@aibees/shared/features/notifications/store';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { NotificationExportToRouteButtonProps as Props } from './types';

export const NotificationExportToRouteButton = memo(
  ({ className, route, title, item }: Props) => {
    const apiDeliver = useUpdateNotificationStatusMutationApi(
      item.id,
      Action.DELIVER
    );
    const markNotificationAsSeen =
      useNotificationStore.useMarkNotificationAsSeen();
    const closeDrawer = useNotificationStore.useCloseDrawer();

    const handleClick = () => {
      if (item.id && item.status === NotificationStatus.SENT) {
        markNotificationAsSeen(item.id);
        apiDeliver.mutateAsync(null);
      }

      window.open(route, '_blank');
      closeDrawer();
    };

    if (
      item.message.metadata.status === NotificationMetadataStatus.PROCESSING
    ) {
      return null;
    }

    return (
      <Styled.Wrapper
        className={classnames('NotificationExportToRouteButton', className)}
        sx={SX.root}
      >
        <Button
          color="primary"
          variant="contained"
          size="small"
          onClick={handleClick}
        >
          {title}
        </Button>
      </Styled.Wrapper>
    );
  }
);

NotificationExportToRouteButton.displayName = 'NotificationExportToRouteButton';
